export default "#define GLSLIFY 1\nvarying vec2 vUv;\nvoid main() {\n\tvUv = vec2(0.5)+(position.xy)*0.5;\n\tgl_Position = vec4( position.xy, 0.0,  1.0 );\n}";